module.exports = __webpack_public_path__ + "img/ninja.81ca859d.svg";